document.addEventListener("DOMContentLoaded", () => {
    const videoTechnicalService = document.querySelector(".video-technical-service-landing");
    const footerForm = document.querySelector(".footer_form");
    const main = document.querySelector("main");
    if (videoTechnicalService && main && footerForm) {
        footerForm.classList.add("page-width");
        main.insertAdjacentElement("beforeend", footerForm);
    }
});

